const DrawingCompassIcon = /*#__PURE__*/ [
  ["path", { d: "M10 10L5 22M14 10L19 22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M12 4L12 2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["circle", { cx: "12", cy: "7", r: "3", stroke: "currentColor", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M3 13C4.99073 16.0242 8.27968 18 12 18C15.7203 18 19.0093 16.0242 21 13", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M12 17V19", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "4" }]
];

export { DrawingCompassIcon as default };
//# sourceMappingURL=DrawingCompassIcon.js.map
